import { render, staticRenderFns } from "./CredentialsView.vue?vue&type=template&id=700c32e5"
import script from "./CredentialsView.vue?vue&type=script&lang=js"
export * from "./CredentialsView.vue?vue&type=script&lang=js"
import style0 from "./CredentialsView.vue?vue&type=style&index=0&id=700c32e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports